import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import withScrollableView from "../../components/scrollable/withScrollableView";
import { PropTypeShapes } from "../../types";
import RelationshipScrollBackgroundView from "./RelationshipScrollBackgroundView";

const RelationshipSyncScroller = props => {
  return (
    <div className="timelineSyncScroller">
      <RelationshipScrollBackgroundView
        fontSize={props.fontSize}
        viewIds={props.viewIds}
        colGroups={props.colGroups}
        width={props.width}
        key="relationshipScrollBackground"
      />
      {props.children}
    </div>
  );
};

RelationshipSyncScroller.propTypes = {
  // Any special instructions when placing the data?
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  width: PropTypes.number.isRequired,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  fontSize: PropTypes.number.isRequired,
  children: PropTypes.element,
  // Also accessed by ScrollableView
  requestViewBoundsForZoom: PropTypes.func.isRequired
};

const scrollableViewOptions = {
  scrollHorizontally: true,
  scrollVertically: false,
  showHorizontalScrollbar: true,
  preRenderMargin: 500
};

export default withScrollableView(RelationshipSyncScroller, scrollableViewOptions);
